// GENERATED by scripts/tritan_quiz_rebuild.py — do not hand-edit.
// Every image URL below returned HTTP 200 with an image/* content-type at build
// time. Hand-patching this file is what produced 41 dead URLs by 2026-08-09;
// re-run the script instead.
const tritanQuizMeta = {
  "breeds": {
    "golden_retriever": "Golden Retriever",
    "french_bulldog": "French Bulldog",
    "siberian_husky": "Siberian Husky",
    "german_shepherd": "German Shepherd",
    "labrador": "Labrador",
    "dachshund": "Dachshund",
    "corgi": "Corgi",
    "rottweiler": "Rottweiler",
    "beagle": "Beagle",
    "australian_shepherd": "Australian Shepherd",
    "english_bulldog": "English Bulldog",
    "poodle": "Poodle",
    "boxer": "Boxer",
    "border_collie": "Border Collie",
    "great_dane": "Great Dane",
    "shih_tzu": "Shih Tzu",
    "boston_terrier": "Boston Terrier"
  },
  "styles": {
    "acrylic": {
      "label": "Acrylic",
      "blurb": "rich and painterly \u2014 the style we built the brand on."
    },
    "oil": {
      "label": "Oil Portrait",
      "blurb": "warm, classic, the one that looks like it has always hung there."
    },
    "royal": {
      "label": "Royal Portrait",
      "blurb": "regal, a little theatrical, entirely deserved."
    },
    "medieval": {
      "label": "Medieval Knight",
      "blurb": "armour, banners, and a completely straight face."
    }
  },
  "surfaces": {
    "canvas": {
      "label": "Canvas",
      "blurb": "gallery-wrapped and ready to hang out of the box."
    },
    "blanket": {
      "label": "Sherpa Blanket",
      "blurb": "the couch upgrade you did not know you needed."
    },
    "mug": {
      "label": "Ceramic Mug",
      "blurb": "their face, every morning, before you are ready for it."
    },
    "coaster": {
      "label": "Cork Coaster",
      "blurb": "small, useful, and quietly theirs."
    },
    "sticker": {
      "label": "Kiss-Cut Sticker",
      "blurb": "for the laptop, the bottle, the bumper."
    },
    "phone_case": {
      "label": "Tough Phone Case",
      "blurb": "carried everywhere, which is the point."
    }
  }
};
const tritanQuizLookup = {
  "golden_retriever": {
    "acrylic": {
      "canvas": {
        "title": "Golden Retriever Painting Canvas Wall Art, Dog Lover Gift, Pet Art Print, Dog Mom Decor, Acrylic Style Stretched Canvas",
        "handle": "golden-retriever-painting-canvas-wall-art-dog-lover-gift-pet-art-print-dog-mom-decor-acrylic-style-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-painting-canvas-wall-art-dog-lover-gift-pet-art-print-dog-mom-decor-acrylic-style-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/golden-retriever-painting-canvas-wall-art-dog-lover-gift-pet-art-print-dog-mom-decor-acrylic-style-stretched-canvas.jpg?v=1784734281"
      },
      "blanket": {
        "title": "Golden Retriever Acrylic Sunset Prairie Throw Blanket | Premium Dog Art | Tritan",
        "handle": "acrylic-painting-golden-retriever-sunset-prairie-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-golden-retriever-sunset-prairie-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/golden-retriever-acrylic-painting-sunset-prairie-sherpa-fleece-blanket-dog-lover-gift.jpg?v=1781196645"
      },
      "mug": {
        "title": "Acrylic Painting Golden Retriever - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-golden-retriever-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-golden-retriever-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/581723836264796441_2048.jpg?v=1785773826"
      },
      "coaster": {
        "title": "Golden Retriever Acrylic Sunset Prairie Drink Coaster | Premium Dog Art | Tritan",
        "handle": "acrylic-painting-golden-retriever-sunset-prairie-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-golden-retriever-sunset-prairie-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/18083344556614020291_2048.jpg?v=1776317215"
      },
      "sticker": {
        "title": "Golden Retriever Acrylic Sunset Prairie Kiss-Cut Stickers | Premium Dog Art | Tritan",
        "handle": "golden-retriever-acrylic-gallery-print-sunset-prairie-kiss-cut-stickers-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-acrylic-gallery-print-sunset-prairie-kiss-cut-stickers-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/6858738620038167762_1200.jpg?v=1781067746"
      },
      "phone_case": {
        "title": "Golden Retriever Acrylic Sunset Prairie Phone Case | Premium Dog Art | Tritan",
        "handle": "acrylic-painting-golden-retriever-sunset-prairie-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-golden-retriever-sunset-prairie-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15776883947904165538_4096.jpg?v=1776317232"
      }
    },
    "oil": {
      "canvas": {
        "title": "Golden Retriever Post-Impressionist Oil Painting Canvas Wall Art - Dog Lover Gift, Pet Decor for Home, Premium Stretched Canvas Print",
        "handle": "golden-retriever-oil-painting-soccer-portrait-canvas-wall-art-dog-lover-gift-pet-decor-for-home-premium-stretched-canvas-print",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-oil-painting-soccer-portrait-canvas-wall-art-dog-lover-gift-pet-decor-for-home-premium-stretched-canvas-print",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/12601688634700169544_2048.jpg?v=1784845468"
      },
      "coaster": {
        "title": "Golden Retriever Post-Impressionist Oil Painting Coaster | Dog Art Gift | Pet Decor",
        "handle": "golden-retriever-oil-painting-soccer-portrait-coaster-dog-art-gift-pet-decor",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-oil-painting-soccer-portrait-coaster-dog-art-gift-pet-decor",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/11467720462075967365_2048.jpg?v=1784847982"
      },
      "phone_case": {
        "title": "Golden Retriever Oil Portrait Tough Phone Case | Premium Dog Art | Tritan",
        "handle": "golden-retriever-oil-portrait-tough-phone-case-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-oil-portrait-tough-phone-case-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/14409066800335291356_4096.jpg?v=1786241866"
      }
    },
    "royal": {
      "canvas": {
        "title": "Golden Retriever Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Golden Retriever Lover Gift, Stretched Canvas",
        "handle": "golden-retriever-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-golden-retriever-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-golden-retriever-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/golden-retriever-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-golden-retriever-lover-gift-stretched-canvas.jpg?v=1784733035"
      },
      "blanket": {
        "title": "Golden Retriever Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "golden-retriever-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/12178666771025644919_2048.jpg?v=1784784328"
      },
      "sticker": {
        "title": "Golden Retriever Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Golden Retriever Lover Gift",
        "handle": "golden-retriever-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-golden-retriever-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-golden-retriever-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/11023211811947885967_1200.jpg?v=1784780374"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Golden Retriever Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Golden Retriever Lover Gift, Stretched Canvas",
        "handle": "golden-retriever-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-golden-retriever-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-golden-retriever-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/golden-retriever-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-golden-retriever-lover-gift-stretched-canvas.jpg?v=1784732471"
      },
      "blanket": {
        "title": "Golden Retriever Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "golden-retriever-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/9982853108228884938_2048.jpg?v=1784780284"
      },
      "sticker": {
        "title": "Golden Retriever Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Golden Retriever Lover Gift",
        "handle": "golden-retriever-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-golden-retriever-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/golden-retriever-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-golden-retriever-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15779539980619016741_1200.jpg?v=1784781407"
      }
    }
  },
  "french_bulldog": {
    "acrylic": {
      "canvas": {
        "title": "French Bulldog Canvas Wall Art Print | Dog Lover Gift, Pet Portrait Home Decor, Modern Acrylic Painting Dog Mom Gift",
        "handle": "french-bulldog-canvas-wall-art-print-dog-lover-gift-pet-portrait-home-decor-modern-acrylic-painting-dog-mom-gift-5",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-canvas-wall-art-print-dog-lover-gift-pet-portrait-home-decor-modern-acrylic-painting-dog-mom-gift-5",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/french-bulldog-canvas-wall-art-print-dog-lover-gift-pet-portrait-home-decor-modern-acrylic-painting-dog-mom-gift.jpg?v=1784733724"
      },
      "blanket": {
        "title": "Acrylic French Bulldog - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-french-bulldog-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-french-bulldog-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-french-bulldog-autumn-woods-sherpa-fleece-blanket_f8e4a625-44e9-466e-a413-35a8ff346629.jpg?v=1781194965"
      },
      "mug": {
        "title": "Acrylic French Bulldog - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-french-bulldog-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-french-bulldog-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/525875995623656898_2048.jpg?v=1785774319"
      },
      "coaster": {
        "title": "Acrylic French Bulldog - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-french-bulldog-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-french-bulldog-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/14184871763510598020_2048.jpg?v=1776670453"
      },
      "sticker": {
        "title": "Acrylic French Bulldog - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-french-bulldog-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-french-bulldog-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10873306945039537870_1200.jpg?v=1776670400"
      },
      "phone_case": {
        "title": "Acrylic French Bulldog - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-french-bulldog-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-french-bulldog-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1533183091991335607_4096.jpg?v=1776670226"
      }
    },
    "oil": {
      "canvas": {
        "title": "French Bulldog Oil Portrait Stretched Canvas | Frenchie Wall Art Decor | Warm Dog Art Print | Pet Lover Gift",
        "handle": "french-bulldog-oil-portrait-stretched-canvas-frenchie-wall-art-decor-warm-dog-art-print-pet-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-oil-portrait-stretched-canvas-frenchie-wall-art-decor-warm-dog-art-print-pet-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/french-bulldog-oil-portrait-stretched-canvas-frenchie-wall-art-decor-warm-dog-art-print-pet-lover-gift.jpg?v=1784731265"
      },
      "blanket": {
        "title": "French Bulldog Oil Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "french-bulldog-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/french-bulldog-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan.jpg?v=1781196446"
      },
      "mug": {
        "title": "French Bulldog Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "french-bulldog-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13548355475930244235_2048.jpg?v=1786201141"
      },
      "coaster": {
        "title": "French Bulldog Post-Impressionist Oil Painting Coaster | Dog Lover Gift | Pet Decor for Home | Cute Frenchie Art",
        "handle": "french-bulldog-oil-painting-soccer-portrait-coaster-dog-lover-gift-pet-decor-for-home-cute-frenchie-art",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-oil-painting-soccer-portrait-coaster-dog-lover-gift-pet-decor-for-home-cute-frenchie-art",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/5047557723649064101_2048.jpg?v=1784847956"
      }
    },
    "royal": {
      "canvas": {
        "title": "French Bulldog Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, French Bulldog Lover Gift, Stretched Canvas",
        "handle": "french-bulldog-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-french-bulldog-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-french-bulldog-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/french-bulldog-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-french-bulldog-lover-gift-stretched-canvas.jpg?v=1784733011"
      },
      "blanket": {
        "title": "French Bulldog Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "french-bulldog-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/11829404096123269920_2048.jpg?v=1784784412"
      },
      "sticker": {
        "title": "French Bulldog Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, French Bulldog Lover Gift",
        "handle": "french-bulldog-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-french-bulldog-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-french-bulldog-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15369749583364404184_1200.jpg?v=1784780446"
      }
    },
    "medieval": {
      "canvas": {
        "title": "French Bulldog Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, French Bulldog Lover Gift, Stretched Canvas",
        "handle": "french-bulldog-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-french-bulldog-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-french-bulldog-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/french-bulldog-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-french-bulldog-lover-gift-stretched-canvas.jpg?v=1784732448"
      },
      "blanket": {
        "title": "French Bulldog Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "french-bulldog-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1206531902574182740_2048.jpg?v=1784780465"
      },
      "sticker": {
        "title": "French Bulldog Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, French Bulldog Lover Gift",
        "handle": "french-bulldog-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-french-bulldog-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/french-bulldog-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-french-bulldog-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13894639085778054564_1200.jpg?v=1784781455"
      }
    }
  },
  "siberian_husky": {
    "acrylic": {
      "canvas": {
        "title": "Siberian Husky Acrylic Painting Canvas Wall Art, Dog Lover Gift, Pet Portrait Print, Modern Home Decor, Stretched Canvas Art",
        "handle": "siberian-husky-acrylic-painting-canvas-wall-art-dog-lover-gift-pet-portrait-print-modern-home-decor-stretched-canvas-art-3",
        "url": "https://dwpxyg-zj.myshopify.com/products/siberian-husky-acrylic-painting-canvas-wall-art-dog-lover-gift-pet-portrait-print-modern-home-decor-stretched-canvas-art-3",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/siberian-husky-acrylic-painting-canvas-wall-art-dog-lover-gift-pet-portrait-print-modern-home-decor-stretched-canvas-art.jpg?v=1784733574"
      },
      "blanket": {
        "title": "Acrylic Siberian Husky - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-siberian-husky-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-siberian-husky-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-siberian-husky-autumn-woods-sherpa-fleece-blanket.jpg?v=1781195229"
      },
      "mug": {
        "title": "Acrylic Painting Siberian Husky - Coastal Cliffside | Ceramic Mug 11oz",
        "handle": "acrylic-painting-siberian-husky-coastal-cliffside-ceramic-mug-11oz-2",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-siberian-husky-coastal-cliffside-ceramic-mug-11oz-2",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/7650252953220932_2048.jpg?v=1785773186"
      },
      "coaster": {
        "title": "Acrylic Siberian Husky - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-siberian-husky-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-siberian-husky-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10512786633510297070_2048.jpg?v=1776699681"
      },
      "sticker": {
        "title": "Acrylic Siberian Husky - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-siberian-husky-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-siberian-husky-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/4653216861617118260_1200.jpg?v=1776699698"
      },
      "phone_case": {
        "title": "Acrylic Siberian Husky - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-siberian-husky-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-siberian-husky-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3728043778648631997_4096.jpg?v=1776699527"
      }
    },
    "oil": {
      "canvas": {
        "title": "Siberian Husky Oil Portrait Canvas Wall Art - Regal Husky Dog Lover Gift - Pet Art Print Home Decor",
        "handle": "siberian-husky-oil-portrait-canvas-wall-art-regal-husky-dog-lover-gift-pet-art-print-home-decor",
        "url": "https://dwpxyg-zj.myshopify.com/products/siberian-husky-oil-portrait-canvas-wall-art-regal-husky-dog-lover-gift-pet-art-print-home-decor",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/siberian-husky-oil-portrait-canvas-wall-art-regal-husky-dog-lover-gift-pet-art-print-home-decor.jpg?v=1784731005"
      },
      "coaster": {
        "title": "Siberian Husky Coaster Post-Impressionist Oil Painting | Dog Art Gift | Husky Decor for Dog Lovers",
        "handle": "siberian-husky-coaster-oil-painting-soccer-portrait-dog-art-gift-husky-decor-for-dog-lovers",
        "url": "https://dwpxyg-zj.myshopify.com/products/siberian-husky-coaster-oil-painting-soccer-portrait-dog-art-gift-husky-decor-for-dog-lovers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/6174400360530726888_2048.jpg?v=1784847931"
      }
    },
    "royal": {
      "canvas": {
        "title": "Siberian Husky Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Siberian Husky Lover Gift, Stretched Canvas",
        "handle": "siberian-husky-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-siberian-husky-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/siberian-husky-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-siberian-husky-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/siberian-husky-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-siberian-husky-lover-gift-stretched-canvas.jpg?v=1784732627"
      },
      "sticker": {
        "title": "Siberian Husky Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Siberian Husky Lover Gift",
        "handle": "siberian-husky-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-siberian-husky-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/siberian-husky-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-siberian-husky-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/9423402056851044293_1200.jpg?v=1784780098"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Siberian Husky Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Siberian Husky Lover Gift, Stretched Canvas",
        "handle": "siberian-husky-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-siberian-husky-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/siberian-husky-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-siberian-husky-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/siberian-husky-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-siberian-husky-lover-gift-stretched-canvas.jpg?v=1784732076"
      },
      "sticker": {
        "title": "Siberian Husky Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Siberian Husky Lover Gift",
        "handle": "siberian-husky-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-siberian-husky-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/siberian-husky-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-siberian-husky-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/9294183218385656267_1200.jpg?v=1784780641"
      }
    }
  },
  "german_shepherd": {
    "acrylic": {
      "canvas": {
        "title": "German Shepherd Acrylic Painting Canvas Print, GSD Dog Lover Wall Art, Pet Portrait Gift, Ready to Hang Home Decor for Dog Moms & Dads",
        "handle": "german-shepherd-acrylic-painting-canvas-print-gsd-dog-lover-wall-art-pet-portrait-gift-ready-to-hang-home-decor-for-dog-moms-dads-2",
        "url": "https://dwpxyg-zj.myshopify.com/products/german-shepherd-acrylic-painting-canvas-print-gsd-dog-lover-wall-art-pet-portrait-gift-ready-to-hang-home-decor-for-dog-moms-dads-2",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/german-shepherd-acrylic-painting-canvas-print-gsd-dog-lover-wall-art-pet-portrait-gift-ready-to-hang-home-decor-for-dog-moms-dads.jpg?v=1784733711"
      },
      "blanket": {
        "title": "Acrylic German Shepherd - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-german-shepherd-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-german-shepherd-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-german-shepherd-autumn-woods-sherpa-fleece-blanket.jpg?v=1781194990"
      },
      "mug": {
        "title": "Acrylic German Shepherd - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-german-shepherd-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-german-shepherd-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3805199948127358987_2048.jpg?v=1785774143"
      },
      "coaster": {
        "title": "Acrylic German Shepherd - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-german-shepherd-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-german-shepherd-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3785363495073715810_2048.jpg?v=1776670915"
      },
      "sticker": {
        "title": "Acrylic German Shepherd - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-german-shepherd-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-german-shepherd-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13661400037692936674_1200.jpg?v=1776670931"
      },
      "phone_case": {
        "title": "Acrylic German Shepherd - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-german-shepherd-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-german-shepherd-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/2483942315343642838_4096.jpg?v=1776670624"
      }
    },
    "oil": {
      "canvas": {
        "title": "German Shepherd Post-Impressionist Oil Painting Canvas Wall Art Decor, Dog Lover Gift, Pet Owner Present, GSD Art Print",
        "handle": "german-shepherd-oil-painting-soccer-portrait-canvas-wall-art-decor-dog-lover-gift-pet-owner-present-gsd-art-print",
        "url": "https://dwpxyg-zj.myshopify.com/products/german-shepherd-oil-painting-soccer-portrait-canvas-wall-art-decor-dog-lover-gift-pet-owner-present-gsd-art-print",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3140477568582470041_2048.jpg?v=1784845280"
      },
      "coaster": {
        "title": "German Shepherd Post-Impressionist Oil Painting Coaster, GSD Art, Dog Lover Gift, Pet Owner Decor, Dog Mom",
        "handle": "german-shepherd-oil-painting-soccer-coaster-gsd-art-print-dog-lover-gift-pet-owner-decor-football-fan-present-dog-mom",
        "url": "https://dwpxyg-zj.myshopify.com/products/german-shepherd-oil-painting-soccer-coaster-gsd-art-print-dog-lover-gift-pet-owner-decor-football-fan-present-dog-mom",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/9605665826382658169_2048.jpg?v=1784847944"
      }
    },
    "royal": {
      "canvas": {
        "title": "German Shepherd Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, German Shepherd Lover Gift, Stretched Canvas",
        "handle": "german-shepherd-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-german-shepherd-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/german-shepherd-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-german-shepherd-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/german-shepherd-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-german-shepherd-lover-gift-stretched-canvas.jpg?v=1784732710"
      },
      "blanket": {
        "title": "German Shepherd Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "german-shepherd-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/german-shepherd-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3517858011574567378_2048.jpg?v=1784784395"
      },
      "sticker": {
        "title": "German Shepherd Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, German Shepherd Lover Gift",
        "handle": "german-shepherd-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-german-shepherd-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/german-shepherd-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-german-shepherd-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/12006756214511844677_1200.jpg?v=1784780410"
      }
    },
    "medieval": {
      "canvas": {
        "title": "German Shepherd Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, German Shepherd Lover Gift, Stretched Canvas",
        "handle": "german-shepherd-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-german-shepherd-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/german-shepherd-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-german-shepherd-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/german-shepherd-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-german-shepherd-lover-gift-stretched-canvas.jpg?v=1784732157"
      },
      "blanket": {
        "title": "German Shepherd Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "german-shepherd-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/german-shepherd-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/18119215236313726003_2048.jpg?v=1784780393"
      },
      "sticker": {
        "title": "German Shepherd Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, German Shepherd Lover Gift",
        "handle": "german-shepherd-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-german-shepherd-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/german-shepherd-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-german-shepherd-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/4300475444954036210_1200.jpg?v=1784781434"
      }
    }
  },
  "labrador": {
    "acrylic": {
      "canvas": {
        "title": "Labrador Retriever Acrylic Painting Canvas Wall Art, Dog Lover Gift, Pet Portrait, Home Decor, Animal Art Print",
        "handle": "labrador-retriever-acrylic-painting-canvas-wall-art-dog-lover-gift-pet-portrait-home-decor-animal-art-print-5",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-acrylic-painting-canvas-wall-art-dog-lover-gift-pet-portrait-home-decor-animal-art-print-5",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/labrador-retriever-acrylic-painting-canvas-wall-art-dog-lover-gift-pet-portrait-home-decor-animal-art-print.jpg?v=1784733685"
      },
      "blanket": {
        "title": "Acrylic Labrador Retriever - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-labrador-retriever-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-labrador-retriever-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-labrador-retriever-autumn-woods-sherpa-fleece-blanket.jpg?v=1781195086"
      },
      "mug": {
        "title": "Acrylic Labrador Retriever - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-labrador-retriever-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-labrador-retriever-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10367590514154549327_2048.jpg?v=1785773138"
      },
      "coaster": {
        "title": "Acrylic Labrador Retriever - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-labrador-retriever-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-labrador-retriever-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/6399011447270857866_2048.jpg?v=1776675614"
      },
      "sticker": {
        "title": "Acrylic Labrador Retriever - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-labrador-retriever-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-labrador-retriever-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/7472380119788970773_1200.jpg?v=1776672532"
      },
      "phone_case": {
        "title": "Acrylic Labrador Retriever - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-labrador-retriever-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-labrador-retriever-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1711351115708249137_4096.jpg?v=1776675475"
      }
    },
    "oil": {
      "canvas": {
        "title": "Labrador Retriever Art, Warm Oil Portrait Canvas Print, Lab Dog Owner Gift, Pet Wall Art Decor for Home",
        "handle": "labrador-retriever-art-warm-oil-portrait-canvas-print-lab-dog-owner-gift-pet-wall-art-decor-for-home",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-art-warm-oil-portrait-canvas-print-lab-dog-owner-gift-pet-wall-art-decor-for-home",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/labrador-retriever-art-warm-oil-portrait-canvas-print-lab-dog-owner-gift-pet-wall-art-decor-for-home.jpg?v=1784731141"
      },
      "blanket": {
        "title": "Labrador Retriever Oil Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "labrador-retriever-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/labrador-retriever-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan.jpg?v=1781197042"
      },
      "mug": {
        "title": "Labrador Retriever Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "labrador-retriever-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/2417377613762007245_2048.jpg?v=1786137615"
      },
      "coaster": {
        "title": "Labrador Retriever Post-Impressionist Oil Painting Coaster | Lab Dog Lover Gift | Pet Art Decor | Funny Dog Coasters",
        "handle": "labrador-retriever-oil-painting-soccer-portrait-coaster-lab-dog-lover-gift-pet-art-decor-funny-dog-coasters",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-oil-painting-soccer-portrait-coaster-lab-dog-lover-gift-pet-art-decor-funny-dog-coasters",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/12768949842488943412_2048.jpg?v=1784847972"
      }
    },
    "royal": {
      "canvas": {
        "title": "Labrador Retriever Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Labrador Retriever Lover Gift, Stretched Canvas",
        "handle": "labrador-retriever-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-labrador-retriever-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-labrador-retriever-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/labrador-retriever-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-labrador-retriever-lover-gift-stretched-canvas.jpg?v=1784732986"
      },
      "blanket": {
        "title": "Labrador Retriever Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "labrador-retriever-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10104757220201132979_2048.jpg?v=1784785181"
      },
      "sticker": {
        "title": "Labrador Retriever Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Labrador Retriever Lover Gift",
        "handle": "labrador-retriever-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-labrador-retriever-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-labrador-retriever-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13864780420200306375_1200.jpg?v=1784780264"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Labrador Retriever Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Labrador Retriever Lover Gift, Stretched Canvas",
        "handle": "labrador-retriever-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-labrador-retriever-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-labrador-retriever-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/labrador-retriever-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-labrador-retriever-lover-gift-stretched-canvas.jpg?v=1784732425"
      },
      "blanket": {
        "title": "Labrador Retriever Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "labrador-retriever-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15804371244622654058_2048.jpg?v=1784780155"
      },
      "sticker": {
        "title": "Labrador Retriever Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Labrador Retriever Lover Gift",
        "handle": "labrador-retriever-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-labrador-retriever-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/labrador-retriever-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-labrador-retriever-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/481209797633076052_1200.jpg?v=1784780741"
      }
    }
  },
  "dachshund": {
    "acrylic": {
      "canvas": {
        "title": "Dachshund Stretched Canvas Wall Art, Acrylic Painting Dog Print, Pet Portrait Gift for Dog Lovers, Modern Animal Home Decor",
        "handle": "dachshund-stretched-canvas-wall-art-acrylic-painting-dog-print-pet-portrait-gift-for-dog-lovers-modern-animal-home-decor-6",
        "url": "https://dwpxyg-zj.myshopify.com/products/dachshund-stretched-canvas-wall-art-acrylic-painting-dog-print-pet-portrait-gift-for-dog-lovers-modern-animal-home-decor-6",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/dachshund-stretched-canvas-wall-art-acrylic-painting-dog-print-pet-portrait-gift-for-dog-lovers-modern-animal-home-decor.jpg?v=1784733738"
      },
      "blanket": {
        "title": "Acrylic Dachshund - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-dachshund-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-dachshund-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-dachshund-autumn-woods-sherpa-fleece-blanket_56db0443-0824-4132-b283-3d0f4abebcd5.jpg?v=1781194916"
      },
      "mug": {
        "title": "Acrylic Dachshund - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-dachshund-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-dachshund-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1215893509664151553_2048.jpg?v=1785774797"
      },
      "coaster": {
        "title": "Acrylic Dachshund - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-dachshund-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-dachshund-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/17986736062101040938_2048.jpg?v=1776669380"
      },
      "sticker": {
        "title": "Acrylic Dachshund - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-dachshund-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-dachshund-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10452948085005493169_1200.jpg?v=1776669549"
      },
      "phone_case": {
        "title": "Acrylic Dachshund - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-dachshund-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-dachshund-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15668500646244145148_4096.jpg?v=1776669402"
      }
    },
    "oil": {
      "canvas": {
        "title": "Dachshund Post-Impressionist Oil Painting Stretched Canvas Wall Art | Funny Dog Decor Gift | Pet Lover Home Art",
        "handle": "dachshund-oil-painting-soccer-portrait-stretched-canvas-wall-art-funny-dog-decor-gift-pet-lover-home-art",
        "url": "https://dwpxyg-zj.myshopify.com/products/dachshund-oil-painting-soccer-portrait-stretched-canvas-wall-art-funny-dog-decor-gift-pet-lover-home-art",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1928239708515202909_2048.jpg?v=1784846453"
      },
      "coaster": {
        "title": "Dachshund Post-Impressionist Player Coaster | Oil Painting Dog Art | Wiener Dog Gift | Pet Portrait Decor",
        "handle": "dachshund-soccer-player-coaster-oil-painting-dog-art-wiener-dog-gift-pet-portrait-decor",
        "url": "https://dwpxyg-zj.myshopify.com/products/dachshund-soccer-player-coaster-oil-painting-dog-art-wiener-dog-gift-pet-portrait-decor",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8438171556281792384_2048.jpg?v=1784847882"
      }
    },
    "royal": {
      "canvas": {
        "title": "Dachshund Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Dachshund Lover Gift, Stretched Canvas",
        "handle": "dachshund-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-dachshund-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/dachshund-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-dachshund-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/dachshund-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-dachshund-lover-gift-stretched-canvas.jpg?v=1784732758"
      },
      "blanket": {
        "title": "Dachshund Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "dachshund-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/dachshund-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/17211101091048920941_2048.jpg?v=1784784446"
      },
      "sticker": {
        "title": "Dachshund Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Dachshund Lover Gift",
        "handle": "dachshund-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-dachshund-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/dachshund-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-dachshund-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15543889691679001609_1200.jpg?v=1784780224"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Dachshund Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Dachshund Lover Gift, Stretched Canvas",
        "handle": "dachshund-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-dachshund-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/dachshund-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-dachshund-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/dachshund-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-dachshund-lover-gift-stretched-canvas.jpg?v=1784732201"
      },
      "blanket": {
        "title": "Dachshund Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "dachshund-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/dachshund-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/949896405949674763_2048.jpg?v=1784780244"
      },
      "sticker": {
        "title": "Dachshund Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Dachshund Lover Gift",
        "handle": "dachshund-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-dachshund-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/dachshund-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-dachshund-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/6354937769614401235_1200.jpg?v=1784781500"
      }
    }
  },
  "corgi": {
    "acrylic": {
      "canvas": {
        "title": "Corgi Acrylic Painting Canvas Wall Art, Dog Lover Gift, Stretched Canvas Print, Cute Pet Home Decor, Animal Art",
        "handle": "corgi-acrylic-painting-canvas-wall-art-dog-lover-gift-stretched-canvas-print-cute-pet-home-decor-animal-art-7",
        "url": "https://dwpxyg-zj.myshopify.com/products/corgi-acrylic-painting-canvas-wall-art-dog-lover-gift-stretched-canvas-print-cute-pet-home-decor-animal-art-7",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/corgi-acrylic-painting-canvas-wall-art-dog-lover-gift-stretched-canvas-print-cute-pet-home-decor-animal-art.jpg?v=1784733752"
      },
      "blanket": {
        "title": "Acrylic Corgi - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-corgi-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-corgi-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-corgi-autumn-woods-sherpa-fleece-blanket.jpg?v=1781194891"
      },
      "mug": {
        "title": "Acrylic Corgi - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-corgi-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-corgi-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/2465526203813258046_2048.jpg?v=1785774818"
      },
      "coaster": {
        "title": "Acrylic Corgi - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-corgi-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-corgi-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/12605956299543046256_2048.jpg?v=1776672502"
      },
      "sticker": {
        "title": "Acrylic Corgi - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-corgi-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-corgi-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16498843749346736914_1200.jpg?v=1776672518"
      },
      "phone_case": {
        "title": "Acrylic Corgi - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-corgi-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-corgi-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/11712244285007464457_4096.jpg?v=1776672362"
      }
    },
    "oil": {
      "canvas": {
        "title": "Corgi Post-Impressionist Oil Painting Canvas, Funny Dog Wall Art Decor, Pembroke Welsh Corgi Lover Gift for Him Her, Pet Art Print",
        "handle": "corgi-oil-painting-soccer-portrait-canvas-funny-dog-wall-art-decor-pembroke-welsh-corgi-lover-gift-for-him-her-pet-art-print",
        "url": "https://dwpxyg-zj.myshopify.com/products/corgi-oil-painting-soccer-portrait-canvas-funny-dog-wall-art-decor-pembroke-welsh-corgi-lover-gift-for-him-her-pet-art-print",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10043582161985116608_2048.jpg?v=1784845231"
      },
      "coaster": {
        "title": "Corgi Post-Impressionist Oil Painting Coaster | Dog Lover Gift | Cute Pet Owner Decor | Corgi Art",
        "handle": "corgi-oil-painting-soccer-portrait-coaster-dog-lover-gift-cute-pet-owner-decor-corgi-art-print",
        "url": "https://dwpxyg-zj.myshopify.com/products/corgi-oil-painting-soccer-portrait-coaster-dog-lover-gift-cute-pet-owner-decor-corgi-art-print",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3761524219973766820_2048.jpg?v=1784847835"
      }
    },
    "royal": {
      "canvas": {
        "title": "Pembroke Welsh Corgi Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Pembroke Welsh Corgi Lover Gift, Stretched Canvas",
        "handle": "pembroke-welsh-corgi-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-pembroke-welsh-corgi-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/pembroke-welsh-corgi-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-pembroke-welsh-corgi-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/pembroke-welsh-corgi-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-pembroke-welsh-corgi-lover-gift-stretched-canvas.jpg?v=1784732963"
      },
      "blanket": {
        "title": "Corgi Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "corgi-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/corgi-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3243518808891222288_2048.jpg?v=1784785165"
      },
      "sticker": {
        "title": "Corgi Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Corgi Lover Gift",
        "handle": "corgi-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-corgi-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/corgi-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-corgi-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3618926158586586734_1200.jpg?v=1784780502"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Pembroke Welsh Corgi Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Pembroke Welsh Corgi Lover Gift, Stretched Canvas",
        "handle": "pembroke-welsh-corgi-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-pembroke-welsh-corgi-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/pembroke-welsh-corgi-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-pembroke-welsh-corgi-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/pembroke-welsh-corgi-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-pembroke-welsh-corgi-lover-gift-stretched-canvas.jpg?v=1784732400"
      },
      "blanket": {
        "title": "Corgi Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "corgi-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/corgi-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13734992544570958120_2048_9ff7e28b-d882-41ec-a3ce-8d9a70d26630.jpg?v=1784780119"
      },
      "sticker": {
        "title": "Corgi Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Corgi Lover Gift",
        "handle": "corgi-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-corgi-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/corgi-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-corgi-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16050659875269929680_1200.jpg?v=1784781521"
      }
    }
  },
  "rottweiler": {
    "acrylic": {
      "canvas": {
        "title": "Rottweiler Painting Canvas Wall Art, Dog Lover Gift, Pet Portrait, Acrylic Original Style Print, Home Decor, Stretched Canvas",
        "handle": "rottweiler-painting-canvas-wall-art-dog-lover-gift-pet-portrait-acrylic-original-style-print-home-decor-stretched-canvas-1",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-painting-canvas-wall-art-dog-lover-gift-pet-portrait-acrylic-original-style-print-home-decor-stretched-canvas-1",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/rottweiler-painting-canvas-wall-art-dog-lover-gift-pet-portrait-acrylic-original-style-print-home-decor-stretched-canvas.jpg?v=1784733603"
      },
      "blanket": {
        "title": "Acrylic Rottweiler - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-rottweiler-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-rottweiler-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-rottweiler-autumn-woods-sherpa-fleece-blanket.jpg?v=1781195183"
      },
      "mug": {
        "title": "Acrylic Painting Rottweiler - Coastal Cliffside | Ceramic Mug 11oz",
        "handle": "acrylic-painting-rottweiler-coastal-cliffside-ceramic-mug-11oz-2",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-rottweiler-coastal-cliffside-ceramic-mug-11oz-2",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16409587496207349268_2048.jpg?v=1785772443"
      },
      "coaster": {
        "title": "Acrylic Rottweiler - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-rottweiler-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-rottweiler-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3413144274383613162_2048.jpg?v=1776674032"
      },
      "sticker": {
        "title": "Acrylic Rottweiler - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-rottweiler-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-rottweiler-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15915166200265315489_1200.jpg?v=1776674047"
      },
      "phone_case": {
        "title": "Acrylic Rottweiler - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-rottweiler-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-rottweiler-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16076257545943510554_4096.jpg?v=1776678026"
      }
    },
    "oil": {
      "canvas": {
        "title": "Rottweiler Oil Portrait Canvas Print | Warm Dog Wall Art | Pet Lover Gift | Gentle Giant Home Decor",
        "handle": "rottweiler-oil-portrait-canvas-print-warm-dog-wall-art-pet-lover-gift-gentle-giant-home-decor",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-oil-portrait-canvas-print-warm-dog-wall-art-pet-lover-gift-gentle-giant-home-decor",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/rottweiler-oil-portrait-canvas-print-warm-dog-wall-art-pet-lover-gift-gentle-giant-home-decor.jpg?v=1784731039"
      },
      "blanket": {
        "title": "Rottweiler Oil Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "rottweiler-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/rottweiler-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan.jpg?v=1781197532"
      },
      "mug": {
        "title": "Rottweiler Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "rottweiler-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/9813502544196975667_2048.jpg?v=1786138637"
      },
      "coaster": {
        "title": "Rottweiler Coaster | Post-Impressionist Oil Painting Dog Art | Pet Gift for Her Him | Dog Lover Decor",
        "handle": "rottweiler-coaster-oil-painting-soccer-portrait-dog-art-pet-gift-for-her-him-dog-lover-decor",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-coaster-oil-painting-soccer-portrait-dog-art-pet-gift-for-her-him-dog-lover-decor",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/2079910300834520310_2048.jpg?v=1784847869"
      }
    },
    "royal": {
      "canvas": {
        "title": "Rottweiler Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Rottweiler Lover Gift, Stretched Canvas",
        "handle": "rottweiler-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-rottweiler-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-rottweiler-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/rottweiler-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-rottweiler-lover-gift-stretched-canvas.jpg?v=1784732543"
      },
      "blanket": {
        "title": "Rottweiler Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "rottweiler-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/849604840744241151_2048.jpg?v=1784782754"
      },
      "sticker": {
        "title": "Rottweiler Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Rottweiler Lover Gift",
        "handle": "rottweiler-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-rottweiler-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-rottweiler-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/5971433970935123221_1200.jpg?v=1784780172"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Rottweiler Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Rottweiler Lover Gift, Stretched Canvas",
        "handle": "rottweiler-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-rottweiler-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-rottweiler-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/rottweiler-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-rottweiler-lover-gift-stretched-canvas.jpg?v=1784731992"
      },
      "blanket": {
        "title": "Rottweiler Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "rottweiler-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8483069456280007111_2048.jpg?v=1784780026"
      },
      "sticker": {
        "title": "Rottweiler Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Rottweiler Lover Gift",
        "handle": "rottweiler-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-rottweiler-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/rottweiler-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-rottweiler-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8788882790351858907_1200.jpg?v=1784780682"
      }
    }
  },
  "beagle": {
    "acrylic": {
      "canvas": {
        "title": "Beagle Wall Art Canvas Print, Dog Mom Gift, Acrylic Painting Pet Portrait, Stretched Canvas Decor, Ready to Hang Dog Lover Art",
        "handle": "beagle-wall-art-canvas-print-dog-mom-gift-acrylic-painting-pet-portrait-stretched-canvas-decor-ready-to-hang-dog-lover-art-4",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-wall-art-canvas-print-dog-mom-gift-acrylic-painting-pet-portrait-stretched-canvas-decor-ready-to-hang-dog-lover-art-4",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/beagle-wall-art-canvas-print-dog-mom-gift-acrylic-painting-pet-portrait-stretched-canvas-decor-ready-to-hang-dog-lover-art.jpg?v=1784733831"
      },
      "blanket": {
        "title": "Acrylic Beagle - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-beagle-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-beagle-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-beagle-autumn-woods-sherpa-fleece-blanket.jpg?v=1781194718"
      },
      "mug": {
        "title": "Acrylic Beagle - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-beagle-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-beagle-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15203769194007966780_2048.jpg?v=1785776065"
      },
      "coaster": {
        "title": "Acrylic Beagle - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-beagle-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-beagle-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16694528086248748610_2048.jpg?v=1776666413"
      },
      "sticker": {
        "title": "Acrylic Beagle - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-beagle-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-beagle-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3860920535548193745_1200.jpg?v=1776697521"
      },
      "phone_case": {
        "title": "Acrylic Beagle - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-beagle-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-beagle-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10393508380925061939_4096.jpg?v=1776697354"
      }
    },
    "oil": {
      "canvas": {
        "title": "Beagle Oil Portrait Canvas Wall Art, Dog Lover Gift, Pet Decor, Stretched Canvas Print. Ideal for Beagle Moms & Dads.",
        "handle": "beagle-oil-portrait-canvas-wall-art-dog-lover-gift-pet-decor-stretched-canvas-print-ideal-for-beagle-moms-dads",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-oil-portrait-canvas-wall-art-dog-lover-gift-pet-decor-stretched-canvas-print-ideal-for-beagle-moms-dads",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/beagle-oil-portrait-canvas-wall-art-dog-lover-gift-pet-decor-stretched-canvas-print-ideal-for-beagle-moms-dads.jpg?v=1784731442"
      },
      "blanket": {
        "title": "Beagle Oil Portrait Throw Blanket | Premium Dog Art | Tritan",
        "handle": "beagle-oil-portrait-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-oil-portrait-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/beagle-oil-portrait-throw-blanket-premium-dog-prints-tritan.jpg?v=1781195530"
      },
      "mug": {
        "title": "Beagle Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "beagle-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/18440585698590417845_2048.jpg?v=1786135224"
      },
      "coaster": {
        "title": "Beagle Coaster | Post-Impressionist Oil Painting Dog Art | Pet Lover Gift & Home Decor",
        "handle": "beagle-coaster-oil-painting-soccer-portrait-dog-art-pet-lover-gift-home-decor",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-coaster-oil-painting-soccer-portrait-dog-art-pet-lover-gift-home-decor",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15805395998807122771_2048.jpg?v=1784847906"
      }
    },
    "royal": {
      "canvas": {
        "title": "Beagle Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Beagle Lover Gift, Stretched Canvas",
        "handle": "beagle-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-beagle-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-beagle-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/beagle-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-beagle-lover-gift-stretched-canvas.jpg?v=1784732917"
      },
      "blanket": {
        "title": "Beagle Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "beagle-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13453746067423994526_2048.jpg?v=1784784519"
      },
      "sticker": {
        "title": "Beagle Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Beagle Lover Gift",
        "handle": "beagle-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-beagle-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-beagle-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/12174614527774130369_1200.jpg?v=1784780421"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Beagle Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Beagle Lover Gift, Stretched Canvas",
        "handle": "beagle-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-beagle-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-beagle-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/beagle-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-beagle-lover-gift-stretched-canvas.jpg?v=1784732354"
      },
      "blanket": {
        "title": "Beagle Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "beagle-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/4278003062414797059_2048.jpg?v=1784780331"
      },
      "sticker": {
        "title": "Beagle Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Beagle Lover Gift",
        "handle": "beagle-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-beagle-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/beagle-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-beagle-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16953857130538906655_1200.jpg?v=1784782246"
      }
    }
  },
  "australian_shepherd": {
    "acrylic": {
      "canvas": {
        "title": "Australian Shepherd Canvas Wall Art Print | Aussie Dog Lover Gift | Dog Art Home Decor | Stretched Acrylic Painting Style",
        "handle": "australian-shepherd-canvas-wall-art-print-aussie-dog-lover-gift-dog-art-home-decor-stretched-acrylic-painting-style-4",
        "url": "https://dwpxyg-zj.myshopify.com/products/australian-shepherd-canvas-wall-art-print-aussie-dog-lover-gift-dog-art-home-decor-stretched-acrylic-painting-style-4",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/australian-shepherd-canvas-wall-art-print-aussie-dog-lover-gift-dog-art-home-decor-stretched-acrylic-painting-style.jpg?v=1784733845"
      },
      "blanket": {
        "title": "Acrylic Australian Shepherd - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-australian-shepherd-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-australian-shepherd-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10974774962556017873_2048.jpg?v=1781824634"
      },
      "mug": {
        "title": "Acrylic Australian Shepherd - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-australian-shepherd-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-australian-shepherd-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/184302012703792357_2048.jpg?v=1785776186"
      },
      "coaster": {
        "title": "Acrylic Australian Shepherd - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-australian-shepherd-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-australian-shepherd-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15660419573050520776_2048.jpg?v=1776665717"
      },
      "sticker": {
        "title": "Acrylic Australian Shepherd - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-australian-shepherd-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-australian-shepherd-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/7332104193733237353_1200.jpg?v=1776665732"
      },
      "phone_case": {
        "title": "Acrylic Australian Shepherd - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-australian-shepherd-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-australian-shepherd-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16217033989438888472_4096.jpg?v=1776665540"
      }
    },
    "oil": {
      "canvas": {
        "title": "Australian Shepherd Post-Impressionist Oil Painting Canvas Art, Aussie Dog Wall Decor, Pet Lover Gift, Dog Mom Dad Present",
        "handle": "australian-shepherd-oil-painting-soccer-portrait-canvas-art-aussie-dog-wall-decor-pet-lover-gift-dog-mom-dad-present",
        "url": "https://dwpxyg-zj.myshopify.com/products/australian-shepherd-oil-painting-soccer-portrait-canvas-art-aussie-dog-wall-decor-pet-lover-gift-dog-mom-dad-present",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16129401957316397247_2048.jpg?v=1784845073"
      },
      "coaster": {
        "title": "Australian Shepherd Coaster Post-Impressionist Oil Painting - Aussie Dog Art Decor, Pet Lover Gift, Puppy Keepsake",
        "handle": "australian-shepherd-coaster-oil-painting-soccer-portrait-aussie-dog-art-decor-pet-lover-gift-puppy-keepsake",
        "url": "https://dwpxyg-zj.myshopify.com/products/australian-shepherd-coaster-oil-painting-soccer-portrait-aussie-dog-art-decor-pet-lover-gift-puppy-keepsake",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/17108254276873484134_2048.jpg?v=1784847824"
      }
    },
    "royal": {
      "canvas": {
        "title": "Australian Shepherd Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Australian Shepherd Lover Gift, Stretched Canvas",
        "handle": "australian-shepherd-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-australian-shepherd-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/australian-shepherd-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-australian-shepherd-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/australian-shepherd-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-australian-shepherd-lover-gift-stretched-canvas.jpg?v=1784732939"
      },
      "blanket": {
        "title": "Australian Shepherd Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "australian-shepherd-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/australian-shepherd-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8546309584012510564_2048.jpg?v=1784784536"
      },
      "sticker": {
        "title": "Australian Shepherd Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Australian Shepherd Lover Gift",
        "handle": "australian-shepherd-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-australian-shepherd-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/australian-shepherd-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-australian-shepherd-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/4002574614357301450_1200.jpg?v=1784780442"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Australian Shepherd Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Australian Shepherd Lover Gift, Stretched Canvas",
        "handle": "australian-shepherd-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-australian-shepherd-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/australian-shepherd-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-australian-shepherd-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/australian-shepherd-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-australian-shepherd-lover-gift-stretched-canvas.jpg?v=1784732377"
      },
      "blanket": {
        "title": "Australian Shepherd Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "australian-shepherd-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/australian-shepherd-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/544971529206999930_2048.jpg?v=1784780386"
      },
      "sticker": {
        "title": "Australian Shepherd Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Australian Shepherd Lover Gift",
        "handle": "australian-shepherd-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-australian-shepherd-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/australian-shepherd-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-australian-shepherd-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15142860247336734427_1200.jpg?v=1784782266"
      }
    }
  },
  "english_bulldog": {
    "acrylic": {
      "canvas": {
        "title": "English Bulldog Canvas Wall Art Print | Dog Lover Gift | Pet Portrait | Modern Acrylic Painting Decor",
        "handle": "english-bulldog-canvas-wall-art-print-dog-lover-gift-pet-portrait-modern-acrylic-painting-decor-4",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-canvas-wall-art-print-dog-lover-gift-pet-portrait-modern-acrylic-painting-decor-4",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/english-bulldog-canvas-wall-art-print-dog-lover-gift-pet-portrait-modern-acrylic-painting-decor.jpg?v=1784734267"
      },
      "blanket": {
        "title": "Acrylic English Bulldog - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-english-bulldog-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-english-bulldog-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-english-bulldog-autumn-woods-sherpa-fleece-blanket.jpg?v=1781194941"
      },
      "mug": {
        "title": "Acrylic English Bulldog - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-english-bulldog-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-english-bulldog-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10555453794733731150_2048.jpg?v=1785770949"
      },
      "coaster": {
        "title": "Acrylic English Bulldog - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-english-bulldog-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-english-bulldog-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/6291168654246421357_2048.jpg?v=1776669761"
      },
      "sticker": {
        "title": "Acrylic English Bulldog - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-english-bulldog-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-english-bulldog-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/3836708351610490691_1200.jpg?v=1776669779"
      },
      "phone_case": {
        "title": "Acrylic English Bulldog - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-english-bulldog-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-english-bulldog-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16098353875386406796_4096.jpg?v=1776697912"
      }
    },
    "oil": {
      "canvas": {
        "title": "English Bulldog Oil Portrait Canvas Print | Bulldog Wall Art | Dog Lover Gift | Pet Portrait Home Decor",
        "handle": "english-bulldog-oil-portrait-canvas-print-bulldog-wall-art-dog-lover-gift-pet-portrait-home-decor",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-oil-portrait-canvas-print-bulldog-wall-art-dog-lover-gift-pet-portrait-home-decor",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/english-bulldog-oil-portrait-canvas-print-bulldog-wall-art-dog-lover-gift-pet-portrait-home-decor.jpg?v=1784731285"
      },
      "blanket": {
        "title": "English Bulldog Oil Portrait Throw Blanket | Premium Dog Art | Tritan",
        "handle": "english-bulldog-oil-portrait-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-oil-portrait-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/english-bulldog-oil-portrait-throw-blanket-premium-dog-prints-tritan.jpg?v=1781196297"
      },
      "mug": {
        "title": "English Bulldog Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "english-bulldog-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/5645902518011762500_2048.jpg?v=1786201148"
      },
      "coaster": {
        "title": "English Bulldog Coaster | Post-Impressionist Oil Painting Dog Art Decor | Pet Lover Gift for Bulldog Owners",
        "handle": "english-bulldog-coaster-oil-painting-soccer-portrait-dog-art-decor-pet-lover-gift-for-bulldog-owners",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-coaster-oil-painting-soccer-portrait-dog-art-decor-pet-lover-gift-for-bulldog-owners",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/5953845907578335564_2048.jpg?v=1784847814"
      }
    },
    "royal": {
      "canvas": {
        "title": "English Bulldog Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, English Bulldog Lover Gift, Stretched Canvas",
        "handle": "english-bulldog-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-english-bulldog-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-english-bulldog-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/english-bulldog-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-english-bulldog-lover-gift-stretched-canvas.jpg?v=1784732734"
      },
      "blanket": {
        "title": "English Bulldog Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "english-bulldog-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1841301339090868591_2048.jpg?v=1784784430"
      },
      "sticker": {
        "title": "English Bulldog Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, English Bulldog Lover Gift",
        "handle": "english-bulldog-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-english-bulldog-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-english-bulldog-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/7474708804528164355_1200.jpg?v=1784780482"
      }
    },
    "medieval": {
      "canvas": {
        "title": "English Bulldog Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, English Bulldog Lover Gift, Stretched Canvas",
        "handle": "english-bulldog-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-english-bulldog-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-english-bulldog-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/english-bulldog-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-english-bulldog-lover-gift-stretched-canvas.jpg?v=1784732179"
      },
      "blanket": {
        "title": "English Bulldog Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "english-bulldog-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/2918230025471775657_2048.jpg?v=1784780209"
      },
      "sticker": {
        "title": "English Bulldog Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, English Bulldog Lover Gift",
        "handle": "english-bulldog-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-english-bulldog-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/english-bulldog-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-english-bulldog-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/4274796459926271572_1200.jpg?v=1784781476"
      }
    }
  },
  "poodle": {
    "acrylic": {
      "canvas": {
        "title": "Poodle Acrylic Art Print Stretched Canvas Wall Art | Dog Lover Gift | Modern Pet Portrait Home Decor | Distinctive Dog Mom Gift",
        "handle": "poodle-acrylic-art-print-stretched-canvas-wall-art-dog-lover-gift-modern-pet-portrait-home-decor-unique-dog-mom-gift-8",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-acrylic-art-print-stretched-canvas-wall-art-dog-lover-gift-modern-pet-portrait-home-decor-unique-dog-mom-gift-8",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/poodle-acrylic-art-print-stretched-canvas-wall-art-dog-lover-gift-modern-pet-portrait-home-decor-unique-dog-mom-gift.jpg?v=1784733637"
      },
      "blanket": {
        "title": "Acrylic Poodle - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-poodle-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-poodle-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-poodle-autumn-woods-sherpa-fleece-blanket.jpg?v=1781195158"
      },
      "mug": {
        "title": "Acrylic Painting Poodle - Coastal Cliffside | Ceramic Mug 11oz",
        "handle": "acrylic-painting-poodle-coastal-cliffside-ceramic-mug-11oz-2",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-poodle-coastal-cliffside-ceramic-mug-11oz-2",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13638592278089002446_2048.jpg?v=1785772486"
      },
      "coaster": {
        "title": "Acrylic Poodle - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-poodle-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-poodle-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8473660705812170253_2048.jpg?v=1776677068"
      },
      "sticker": {
        "title": "Acrylic Poodle - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-poodle-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-poodle-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/76369363188119330_1200.jpg?v=1776677083"
      },
      "phone_case": {
        "title": "Acrylic Poodle - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-poodle-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-poodle-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/7689636587474568801_4096.jpg?v=1776676925"
      }
    },
    "oil": {
      "canvas": {
        "title": "Poodle Oil Portrait Canvas Print, Elegant Dog Wall Art, Poodle Lover Gift, Sophisticated Pet Decor",
        "handle": "poodle-oil-portrait-canvas-print-elegant-dog-wall-art-poodle-lover-gift-sophisticated-pet-decor",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-oil-portrait-canvas-print-elegant-dog-wall-art-poodle-lover-gift-sophisticated-pet-decor",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/poodle-oil-portrait-canvas-print-elegant-dog-wall-art-poodle-lover-gift-sophisticated-pet-decor.jpg?v=1784731077"
      },
      "blanket": {
        "title": "Poodle Oil Portrait Throw Blanket | Premium Dog Art | Tritan",
        "handle": "poodle-oil-portrait-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-oil-portrait-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/poodle-oil-portrait-throw-blanket-premium-dog-prints-tritan.jpg?v=1781197379"
      },
      "mug": {
        "title": "Poodle Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "poodle-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1517304625132186637_2048.jpg?v=1786138196"
      },
      "coaster": {
        "title": "Poodle Post-Impressionist Oil Painting Coaster | Poodle Art Gift | Dog Mom Decor",
        "handle": "poodle-oil-painting-soccer-portrait-coaster-poodle-art-gift-dog-mom-decor",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-oil-painting-soccer-portrait-coaster-poodle-art-gift-dog-mom-decor",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8146701031903881050_2048.jpg?v=1784847893"
      }
    },
    "royal": {
      "canvas": {
        "title": "Poodle Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Poodle Lover Gift, Stretched Canvas",
        "handle": "poodle-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-poodle-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-poodle-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/poodle-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-poodle-lover-gift-stretched-canvas.jpg?v=1784732566"
      },
      "blanket": {
        "title": "Poodle Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "poodle-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/11969112458194148004_2048.jpg?v=1784782770"
      },
      "sticker": {
        "title": "Poodle Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Poodle Lover Gift",
        "handle": "poodle-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-poodle-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-poodle-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/14366516211925088152_1200.jpg?v=1784780209"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Poodle Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Poodle Lover Gift, Stretched Canvas",
        "handle": "poodle-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-poodle-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-poodle-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/poodle-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-poodle-lover-gift-stretched-canvas.jpg?v=1784732015"
      },
      "blanket": {
        "title": "Poodle Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "poodle-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/6453844746694889223_2048.jpg?v=1784780044"
      },
      "sticker": {
        "title": "Poodle Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Poodle Lover Gift",
        "handle": "poodle-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-poodle-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/poodle-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-poodle-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/17054849097383928640_1200.jpg?v=1784780701"
      }
    }
  },
  "boxer": {
    "acrylic": {
      "canvas": {
        "title": "Boxer Dog Painting, Stretched Canvas Wall Art, Modern Pet Decor, Boxer Mom Dad Gift, Acrylic Dog Art Print",
        "handle": "boxer-dog-painting-stretched-canvas-wall-art-modern-pet-decor-boxer-mom-dad-gift-acrylic-dog-art-print-3",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-dog-painting-stretched-canvas-wall-art-modern-pet-decor-boxer-mom-dad-gift-acrylic-dog-art-print-3",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boxer-dog-painting-stretched-canvas-wall-art-modern-pet-decor-boxer-mom-dad-gift-acrylic-dog-art-print.jpg?v=1784733792"
      },
      "blanket": {
        "title": "Acrylic Boxer - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-boxer-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-boxer-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-boxer-autumn-woods-sherpa-fleece-blanket.jpg?v=1781194818"
      },
      "mug": {
        "title": "Acrylic Boxer - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-boxer-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-boxer-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1878162487023361525_2048.jpg?v=1785770955"
      },
      "coaster": {
        "title": "Acrylic Boxer - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-boxer-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-boxer-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/6204536965053278938_2048.jpg?v=1776697576"
      },
      "sticker": {
        "title": "Acrylic Boxer - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-boxer-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-boxer-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/452073756256321384_1200.jpg?v=1776669072"
      },
      "phone_case": {
        "title": "Acrylic Boxer - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-boxer-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-boxer-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/17439407606906119001_4096.jpg?v=1776697409"
      }
    },
    "oil": {
      "canvas": {
        "title": "Boxer Dog Post-Impressionist Oil Painting Canvas Wall Art Decor Gift for Dog Lover",
        "handle": "boxer-dog-oil-painting-soccer-portrait-canvas-wall-art-decor-gift-for-dog-lover",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-dog-oil-painting-soccer-portrait-canvas-wall-art-decor-gift-for-dog-lover",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13500962269027528519_2048.jpg?v=1784845562"
      },
      "blanket": {
        "title": "Boxer Oil Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "boxer-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boxer-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan.jpg?v=1781195828"
      },
      "mug": {
        "title": "Boxer Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "boxer-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8019363964943624269_2048.jpg?v=1786136616"
      },
      "coaster": {
        "title": "Boxer Coaster, Post-Impressionist Oil Painting Dog Art Decor, Boxer Lover Gift for Him Her",
        "handle": "boxer-coaster-oil-painting-soccer-portrait-dog-art-decor-boxer-lover-gift-for-him-her",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-coaster-oil-painting-soccer-portrait-dog-art-decor-boxer-lover-gift-for-him-her",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/703564661519404790_2048.jpg?v=1784847859"
      }
    },
    "royal": {
      "canvas": {
        "title": "Boxer Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Boxer Lover Gift, Stretched Canvas",
        "handle": "boxer-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-boxer-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-boxer-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boxer-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-boxer-lover-gift-stretched-canvas.jpg?v=1784732820"
      },
      "blanket": {
        "title": "Boxer Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "boxer-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8213922144084825813_2048.jpg?v=1784784487"
      },
      "sticker": {
        "title": "Boxer Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Boxer Lover Gift",
        "handle": "boxer-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-boxer-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-boxer-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/12128347175164702734_1200.jpg?v=1784780313"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Boxer Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Boxer Lover Gift, Stretched Canvas",
        "handle": "boxer-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-boxer-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-boxer-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boxer-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-boxer-lover-gift-stretched-canvas.jpg?v=1784732262"
      },
      "blanket": {
        "title": "Boxer Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "boxer-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/17634779039492038049_2048.jpg?v=1784780260"
      },
      "sticker": {
        "title": "Boxer Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Boxer Lover Gift",
        "handle": "boxer-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-boxer-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/boxer-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-boxer-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/2819076224602221931_1200.jpg?v=1784781562"
      }
    }
  },
  "border_collie": {
    "acrylic": {
      "canvas": {
        "title": "Border Collie Canvas Wall Art, Dog Lover Gift, Pet Portrait Print, Acrylic Painting Style, Animal Home Decor",
        "handle": "border-collie-canvas-wall-art-dog-lover-gift-pet-portrait-print-acrylic-painting-style-animal-home-decor-2",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-canvas-wall-art-dog-lover-gift-pet-portrait-print-acrylic-painting-style-animal-home-decor-2",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/border-collie-canvas-wall-art-dog-lover-gift-pet-portrait-print-acrylic-painting-style-animal-home-decor.jpg?v=1784733818"
      },
      "blanket": {
        "title": "Acrylic Border Collie - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-border-collie-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-border-collie-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-border-collie-autumn-woods-sherpa-fleece-blanket.jpg?v=1781194767"
      },
      "mug": {
        "title": "Acrylic Border Collie - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-border-collie-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-border-collie-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/17548121334340356145_2048.jpg?v=1785775539"
      },
      "coaster": {
        "title": "Acrylic Border Collie - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-border-collie-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-border-collie-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13765337884983008276_2048.jpg?v=1776667745"
      },
      "sticker": {
        "title": "Acrylic Border Collie - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-border-collie-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-border-collie-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/5030368485158375830_1200.jpg?v=1776667760"
      },
      "phone_case": {
        "title": "Acrylic Border Collie - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-border-collie-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-border-collie-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15853173257394970958_4096.jpg?v=1776667588"
      }
    },
    "oil": {
      "canvas": {
        "title": "Border Collie Oil Portrait Wall Art Canvas, Dog Lover Gift, Pet Decor, Stretched Canvas Print, Animal Art for Home",
        "handle": "border-collie-oil-portrait-wall-art-canvas-dog-lover-gift-pet-decor-stretched-canvas-print-animal-art-for-home",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-oil-portrait-wall-art-canvas-dog-lover-gift-pet-decor-stretched-canvas-print-animal-art-for-home",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/border-collie-oil-portrait-wall-art-canvas-dog-lover-gift-pet-decor-stretched-canvas-print-animal-art-for-home.jpg?v=1784731400"
      },
      "blanket": {
        "title": "Border Collie Oil Portrait Throw Blanket | Premium Dog Art | Tritan",
        "handle": "border-collie-oil-portrait-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-oil-portrait-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/border-collie-oil-portrait-throw-blanket-premium-dog-prints-tritan.jpg?v=1781195688"
      },
      "mug": {
        "title": "Border Collie Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "border-collie-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10350458644907512917_2048.jpg?v=1786136315"
      },
      "coaster": {
        "title": "Border Collie Post-Impressionist Oil Painting Coaster - Dog Art Gift, Pet Decor",
        "handle": "border-collie-oil-painting-soccer-portrait-coaster-dog-art-gift-pet-decor-sports-fan-present",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-oil-painting-soccer-portrait-coaster-dog-art-gift-pet-decor-sports-fan-present",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13368399154146358072_2048.jpg?v=1784847919"
      }
    },
    "royal": {
      "canvas": {
        "title": "Border Collie Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Border Collie Lover Gift, Stretched Canvas",
        "handle": "border-collie-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-border-collie-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-border-collie-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/border-collie-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-border-collie-lover-gift-stretched-canvas.jpg?v=1784732871"
      },
      "blanket": {
        "title": "Border Collie Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "border-collie-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/12618502625523655501_2048.jpg?v=1784784378"
      },
      "sticker": {
        "title": "Border Collie Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Border Collie Lover Gift",
        "handle": "border-collie-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-border-collie-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-border-collie-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/11678591650078215159_1200.jpg?v=1784780367"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Border Collie Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Border Collie Lover Gift, Stretched Canvas",
        "handle": "border-collie-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-border-collie-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-border-collie-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/border-collie-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-border-collie-lover-gift-stretched-canvas.jpg?v=1784732308"
      },
      "blanket": {
        "title": "Border Collie Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "border-collie-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/11256231603343457010_2048.jpg?v=1784780356"
      },
      "sticker": {
        "title": "Border Collie Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Border Collie Lover Gift",
        "handle": "border-collie-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-border-collie-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/border-collie-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-border-collie-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1292731300977772468_1200.jpg?v=1784781606"
      }
    }
  },
  "great_dane": {
    "acrylic": {
      "canvas": {
        "title": "Great Dane Canvas Wall Art | Dog Lover Gift | Acrylic Painting Style | Pet Portrait Home Decor | Stretched Canvas Print",
        "handle": "great-dane-canvas-wall-art-dog-lover-gift-acrylic-painting-style-pet-portrait-home-decor-stretched-canvas-print",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-canvas-wall-art-dog-lover-gift-acrylic-painting-style-pet-portrait-home-decor-stretched-canvas-print",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/great-dane-canvas-wall-art-dog-lover-gift-acrylic-painting-style-pet-portrait-home-decor-stretched-canvas-print.jpg?v=1784734321"
      },
      "blanket": {
        "title": "Acrylic Great Dane - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-great-dane-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-great-dane-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-great-dane-autumn-woods-sherpa-fleece-blanket.jpg?v=1781195037"
      },
      "mug": {
        "title": "Acrylic Great Dane - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-great-dane-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-great-dane-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/2675074197724165180_2048.jpg?v=1785773820"
      },
      "coaster": {
        "title": "Acrylic Great Dane - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-great-dane-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-great-dane-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/9003501475705851228_2048.jpg?v=1776672840"
      },
      "sticker": {
        "title": "Acrylic Great Dane - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-great-dane-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-great-dane-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/11917336723803305127_1200.jpg?v=1776672858"
      },
      "phone_case": {
        "title": "Acrylic Great Dane - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-great-dane-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-great-dane-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/17173875101037241841_4096.jpg?v=1776672698"
      }
    },
    "oil": {
      "canvas": {
        "title": "Great Dane Oil Portrait Canvas Art | Stretched Dog Wall Decor | Pet Lover Gift | Warm Painting Print",
        "handle": "great-dane-oil-portrait-canvas-art-stretched-dog-wall-decor-pet-lover-gift-warm-painting-print",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-oil-portrait-canvas-art-stretched-dog-wall-decor-pet-lover-gift-warm-painting-print",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/great-dane-oil-portrait-canvas-art-stretched-dog-wall-decor-pet-lover-gift-warm-painting-print.jpg?v=1784731184"
      },
      "blanket": {
        "title": "Great Dane Oil Portrait Warm Throw Blanket | Premium Dog Art | Tritan",
        "handle": "great-dane-oil-portrait-warm-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-oil-portrait-warm-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/great-dane-oil-portrait-warm-throw-blanket-premium-dog-prints-tritan.jpg?v=1781196841"
      },
      "mug": {
        "title": "Great Dane Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "great-dane-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/5031947179233069490_2048.jpg?v=1786200943"
      },
      "coaster": {
        "title": "Great Dane Coaster, Post-Impressionist Oil Painting Dog Art Decor, Great Dane Gift, Dog Lover Home Decor, Pet Owner Drink Mat",
        "handle": "great-dane-coaster-oil-painting-soccer-portrait-dog-art-decor-great-dane-gift-dog-lover-home-decor-pet-owner-drink-mat",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-coaster-oil-painting-soccer-portrait-dog-art-decor-great-dane-gift-dog-lover-home-decor-pet-owner-drink-mat",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/6880511983789425213_2048.jpg?v=1784847846"
      }
    },
    "royal": {
      "canvas": {
        "title": "Great Dane Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Great Dane Lover Gift, Stretched Canvas",
        "handle": "great-dane-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-great-dane-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-great-dane-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/great-dane-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-great-dane-lover-gift-stretched-canvas.jpg?v=1784732673"
      },
      "blanket": {
        "title": "Great Dane Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "great-dane-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/15177464933640320947_2048.jpg?v=1784784310"
      },
      "sticker": {
        "title": "Great Dane Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Great Dane Lover Gift",
        "handle": "great-dane-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-great-dane-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-great-dane-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16593929488561670705_1200.jpg?v=1784780337"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Great Dane Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Great Dane Lover Gift, Stretched Canvas",
        "handle": "great-dane-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-great-dane-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-great-dane-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/great-dane-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-great-dane-lover-gift-stretched-canvas.jpg?v=1784732122"
      },
      "blanket": {
        "title": "Great Dane Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "great-dane-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/14336187265884104041_2048.jpg?v=1784780228"
      },
      "sticker": {
        "title": "Great Dane Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Great Dane Lover Gift",
        "handle": "great-dane-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-great-dane-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/great-dane-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-great-dane-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/10408153276225196857_1200.jpg?v=1784781383"
      }
    }
  },
  "shih_tzu": {
    "acrylic": {
      "canvas": {
        "title": "Shih Tzu Art Print, Dog Wall Art Canvas, Pet Lover Gift, Acrylic Painting Style, Stretched Canvas Decor, Dog Mom Present",
        "handle": "shih-tzu-art-print-dog-wall-art-canvas-pet-lover-gift-acrylic-painting-style-stretched-canvas-decor-dog-mom-present-4",
        "url": "https://dwpxyg-zj.myshopify.com/products/shih-tzu-art-print-dog-wall-art-canvas-pet-lover-gift-acrylic-painting-style-stretched-canvas-decor-dog-mom-present-4",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/shih-tzu-art-print-dog-wall-art-canvas-pet-lover-gift-acrylic-painting-style-stretched-canvas-decor-dog-mom-present.jpg?v=1784733587"
      },
      "blanket": {
        "title": "Acrylic Shih Tzu - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-shih-tzu-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-shih-tzu-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-shih-tzu-autumn-woods-sherpa-fleece-blanket_8783e97d-e77d-499b-a4ec-461e037c0de3.jpg?v=1781195206"
      },
      "mug": {
        "title": "Acrylic Shih Tzu - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-shih-tzu-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-shih-tzu-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/9610700456920527137_2048.jpg?v=1785772425"
      },
      "coaster": {
        "title": "Acrylic Shih Tzu - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-shih-tzu-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-shih-tzu-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/2741053075014577896_2048.jpg?v=1776674622"
      },
      "sticker": {
        "title": "Acrylic Shih Tzu - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-shih-tzu-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-shih-tzu-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8183816560109093286_1200.jpg?v=1776674636"
      },
      "phone_case": {
        "title": "Acrylic Shih Tzu - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-shih-tzu-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-shih-tzu-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8921843607907980216_4096.jpg?v=1776674710"
      }
    },
    "oil": {
      "canvas": {
        "title": "Shih Tzu Oil Painting Canvas Wall Art | Warm Dog Portrait | Pet Lover Gift | Stretched Canvas Decor for Shih Tzu Owners",
        "handle": "shih-tzu-oil-painting-canvas-wall-art-warm-dog-portrait-pet-lover-gift-stretched-canvas-decor-for-shih-tzu-owners",
        "url": "https://dwpxyg-zj.myshopify.com/products/shih-tzu-oil-painting-canvas-wall-art-warm-dog-portrait-pet-lover-gift-stretched-canvas-decor-for-shih-tzu-owners",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/shih-tzu-oil-painting-canvas-wall-art-warm-dog-portrait-pet-lover-gift-stretched-canvas-decor-for-shih-tzu-owners.jpg?v=1784731017"
      },
      "blanket": {
        "title": "Shih Tzu Oil Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "shih-tzu-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/shih-tzu-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/shih-tzu-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan.jpg?v=1781197705"
      },
      "mug": {
        "title": "Shih Tzu Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "shih-tzu-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/shih-tzu-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/16557391668931978205_2048.jpg?v=1786201187"
      }
    },
    "royal": {
      "canvas": {
        "title": "Shih Tzu Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Shih Tzu Lover Gift, Stretched Canvas",
        "handle": "shih-tzu-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-shih-tzu-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/shih-tzu-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-shih-tzu-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/shih-tzu-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-shih-tzu-lover-gift-stretched-canvas.jpg?v=1784732518"
      },
      "blanket": {
        "title": "Shih Tzu Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "shih-tzu-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/shih-tzu-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/6571875346466656249_2048.jpg?v=1784782738"
      },
      "sticker": {
        "title": "Shih Tzu Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Shih Tzu Lover Gift",
        "handle": "shih-tzu-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-shih-tzu-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/shih-tzu-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-shih-tzu-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/2776039217790146616_1200.jpg?v=1784780136"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Shih Tzu Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Shih Tzu Lover Gift, Stretched Canvas",
        "handle": "shih-tzu-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-shih-tzu-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/shih-tzu-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-shih-tzu-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/shih-tzu-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-shih-tzu-lover-gift-stretched-canvas.jpg?v=1784731968"
      },
      "blanket": {
        "title": "Shih Tzu Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "shih-tzu-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/shih-tzu-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/14384758797244716451_2048.jpg?v=1784780009"
      },
      "sticker": {
        "title": "Shih Tzu Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Shih Tzu Lover Gift",
        "handle": "shih-tzu-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-shih-tzu-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/shih-tzu-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-shih-tzu-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/14023488172637995682_1200.jpg?v=1784780661"
      }
    }
  },
  "boston_terrier": {
    "acrylic": {
      "canvas": {
        "title": "Boston Terrier Wall Art Canvas Print, Dog Lover Gift, Pet Portrait Acrylic Painting Home Decor, Cute Animal Art Gift",
        "handle": "boston-terrier-wall-art-canvas-print-dog-lover-gift-pet-portrait-acrylic-painting-home-decor-cute-animal-art-gift-5",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-wall-art-canvas-print-dog-lover-gift-pet-portrait-acrylic-painting-home-decor-cute-animal-art-gift-5",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boston-terrier-wall-art-canvas-print-dog-lover-gift-pet-portrait-acrylic-painting-home-decor-cute-animal-art-gift.jpg?v=1784733805"
      },
      "blanket": {
        "title": "Acrylic Boston Terrier - Autumn Woods | Sherpa Fleece Blanket",
        "handle": "acrylic-painting-boston-terrier-autumn-woods-sherpa-fleece-blanket",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-boston-terrier-autumn-woods-sherpa-fleece-blanket",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/acrylic-painting-boston-terrier-autumn-woods-sherpa-fleece-blanket.jpg?v=1781194792"
      },
      "mug": {
        "title": "Acrylic Boston Terrier - Autumn Woods | Ceramic Mug 11oz",
        "handle": "acrylic-painting-boston-terrier-autumn-woods-ceramic-mug-11oz",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-boston-terrier-autumn-woods-ceramic-mug-11oz",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/13827495826597383490_2048.jpg?v=1785775327"
      },
      "coaster": {
        "title": "Acrylic Boston Terrier - Autumn Woods | Cork Back Coaster",
        "handle": "acrylic-painting-boston-terrier-autumn-woods-cork-back-coaster",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-boston-terrier-autumn-woods-cork-back-coaster",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8980684914110321793_2048.jpg?v=1776668777"
      },
      "sticker": {
        "title": "Acrylic Boston Terrier - Autumn Woods | Kiss-Cut Stickers",
        "handle": "acrylic-painting-boston-terrier-autumn-woods-kiss-cut-stickers",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-boston-terrier-autumn-woods-kiss-cut-stickers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1004602202609242086_1200.jpg?v=1776668794"
      },
      "phone_case": {
        "title": "Acrylic Boston Terrier - Autumn Woods | Tough Phone Case",
        "handle": "acrylic-painting-boston-terrier-autumn-woods-tough-phone-case",
        "url": "https://dwpxyg-zj.myshopify.com/products/acrylic-painting-boston-terrier-autumn-woods-tough-phone-case",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/2551572762231724333_4096.jpg?v=1776668610"
      }
    },
    "oil": {
      "canvas": {
        "title": "Boston Terrier Oil Portrait Canvas Wall Art | Dog Lover Gift | Pet Memorial Decor | Boston Terrier Mom Dad Gift",
        "handle": "boston-terrier-oil-portrait-canvas-wall-art-dog-lover-gift-pet-memorial-decor-boston-terrier-mom-dad-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-oil-portrait-canvas-wall-art-dog-lover-gift-pet-memorial-decor-boston-terrier-mom-dad-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boston-terrier-oil-portrait-canvas-wall-art-dog-lover-gift-pet-memorial-decor-boston-terrier-mom-dad-gift.jpg?v=1784731379"
      },
      "blanket": {
        "title": "Boston Terrier Oil Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "boston-terrier-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boston-terrier-oil-portrait-regal-throw-blanket-premium-dog-prints-tritan.jpg?v=1781195753"
      },
      "mug": {
        "title": "Boston Terrier Oil Portrait Ceramic Mug 11oz | Premium Dog Art | Tritan",
        "handle": "boston-terrier-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-oil-portrait-ceramic-mug-11oz-premium-dog-art-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/971711376443443255_2048.jpg?v=1786136474"
      },
      "coaster": {
        "title": "Boston Terrier Post-Impressionist Oil Painting Coaster | Dog Art Decor Gift | Premium Pet Portrait Drink Mat for Dog Lovers",
        "handle": "boston-terrier-oil-painting-soccer-coaster-dog-art-decor-gift-premium-pet-portrait-drink-mat-for-dog-lovers",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-oil-painting-soccer-coaster-dog-art-decor-gift-premium-pet-portrait-drink-mat-for-dog-lovers",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/4968537279313189748_2048.jpg?v=1784847785"
      }
    },
    "royal": {
      "canvas": {
        "title": "Boston Terrier Kings & Queens Royal Portrait Canvas Wall Art, Regal Dog Painting, Boston Terrier Lover Gift, Stretched Canvas",
        "handle": "boston-terrier-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-boston-terrier-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-boston-terrier-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boston-terrier-kings-queens-royal-portrait-canvas-wall-art-regal-dog-painting-boston-terrier-lover-gift-stretched-canvas.jpg?v=1784732845"
      },
      "blanket": {
        "title": "Boston Terrier Kings & Queens Royal Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "boston-terrier-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-kings-queens-royal-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1657908807797723963_2048.jpg?v=1784784361"
      },
      "sticker": {
        "title": "Boston Terrier Kings & Queens Royal Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Boston Terrier Lover Gift",
        "handle": "boston-terrier-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-boston-terrier-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-kings-queens-royal-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-boston-terrier-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/7832989463746904545_1200.jpg?v=1784780348"
      }
    },
    "medieval": {
      "canvas": {
        "title": "Boston Terrier Medieval Knight Portrait Canvas Wall Art, Regal Dog Painting, Boston Terrier Lover Gift, Stretched Canvas",
        "handle": "boston-terrier-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-boston-terrier-lover-gift-stretched-canvas",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-boston-terrier-lover-gift-stretched-canvas",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/boston-terrier-medieval-knight-portrait-canvas-wall-art-regal-dog-painting-boston-terrier-lover-gift-stretched-canvas.jpg?v=1784732285"
      },
      "blanket": {
        "title": "Boston Terrier Medieval Knight Portrait Regal Throw Blanket | Premium Dog Art | Tritan",
        "handle": "boston-terrier-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-medieval-knight-portrait-regal-throw-blanket-premium-dog-prints-tritan",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/1065015937937425616_2048.jpg?v=1784780297"
      },
      "sticker": {
        "title": "Boston Terrier Medieval Knight Portrait Sticker, Dog Portrait Vinyl Decal, Kiss-Cut Sticker, Boston Terrier Lover Gift",
        "handle": "boston-terrier-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-boston-terrier-lover-gift",
        "url": "https://dwpxyg-zj.myshopify.com/products/boston-terrier-medieval-knight-portrait-sticker-dog-portrait-vinyl-decal-kiss-cut-sticker-boston-terrier-lover-gift",
        "image": "https://cdn.shopify.com/s/files/1/0700/5745/9861/files/8721663960164269077_1200.jpg?v=1784781584"
      }
    }
  }
};
